// extracted by mini-css-extract-plugin
module.exports = {"BlogsList":"BlogsList-module--BlogsList--35-UL","BlogsListOrig":"BlogsList-module--BlogsListOrig--OdrkI"};